import * as React from 'react';

const expandedList = (props) => {
    return (
        <ul className="list-items">
            {props && props.listItems && props.listItems.length > 0 ? props.listItems.map(m =>
                <li key={props.keyItem(m)} style={{ cursor: 'unset' }}>
                    <div className="item-info" onClick={() => props.expandData(m)} style={props.infoStyle}>
                        <div className="item-name">
                            {props.itemName(m)}
                        </div>
                        <div className="item-desc">
                            {props.itemDesc(m)}
                        </div>
                    </div>
                    <div className="item-actions" onClick={() => props.expandData(m)}>
                        {props.itemActions(m)}
                    </div>
                    {props.isExpandable ?
                        props.expandedPanel(m)
                        : null}
                </li>
            ) : null}
        </ul>

    )
}

export default expandedList;
